const getAuthHeader = () => {
  const user = JSON.parse(sessionStorage.getItem("user"));

  if (user && user.authToken) {
    return "Bearer " + user.authToken;
  } else {
    return "";
  }
};

export default getAuthHeader;
